import { TextField } from "@mui/material";
import React from "react";
import { observer } from "mobx-react-lite";

const InputText = ({
    register,
    errors,
    id,
    label,
    options,
    maxWidth,
    autoComplete,
    type,
    defaultValue,
    disabled = false,
}) => {
    const [value, setValue] = React.useState(defaultValue || "");
    const { onChange: rhfOnChange, ...rhfRest } = register(id, options);

    return (
        <TextField
            sx={{
                "& .MuiInputBase-root": { backgroundColor: "white" },
                "& .MuiFormHelperText-root": { textAlign: "left", marginLeft: 0 },
            }}
            style={{ maxWidth: maxWidth || "100%" }}
            fullWidth
            error={!!errors[id]}
            label={label}
            type={type || undefined}
            value={value}
            onChange={(e) => {
                setValue(e.target.value);
                rhfOnChange(e);
            }}
            helperText={
                errors[id]?.message ||
                (options?.maxLength ? `${value.length} / ${options.maxLength}` : undefined)
            }
            inputProps={{ maxLength: options?.maxLength }}
            autoComplete={autoComplete || undefined}
            disabled={disabled}
            {...rhfRest}
        />
    );
};

export default observer(InputText);
